import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRow: {
    margin: theme.spacing(1, 0),
  },
  parent: {
    padding: theme.spacing(0, 0, 2),
  },
  containerPaper: {
    padding: theme.spacing(2),
  },
  containerChild: {
    padding: theme.spacing(0, 0, 0, 4),
  },
}));

export default useStyles;
